<script lang="ts">
	import Blok from '$lib/storyblok/blok.svelte';
	import { editable } from '$lib/storyblok/editable';
	import type { ISbStoryData } from '@storyblok/js';
	import type { HTMLAttributes } from 'svelte/elements';

	interface Props extends HTMLAttributes<HTMLDivElement> {
		content: ISbStoryData<{
			body: ISbStoryData[];
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="bg-gradient py-10 lg:py-14">
	{#each content.body || [] as block}
		<Blok content={block} />
	{/each}
</div>

<style>
	.bg-gradient {
		background: linear-gradient(0deg, #ab7650 0%, #7f4b26 100%);
	}
</style>
